module.exports = __webpack_public_path__ + "media/dashboard/assets/images/sidebar/bell-b8bacb30c2b6b13b4b0765ddd24aad29.svg";